/** Clears legacy UI keys; real auth is the HttpOnly cookie cleared via POST /api/Auth/logout. */
export function clearStoredAuthSession() {
  try {
    localStorage.removeItem("willplayUser");
    localStorage.removeItem("willplay_active_api_base");
  } catch {
    /* ignore */
  }
  try {
    window.dispatchEvent(new CustomEvent("willplay:session-expired"));
  } catch {
    /* ignore */
  }
}

export function sanitizeApiMessage(raw) {
  if (raw == null) return "Something went wrong. Try again.";
  const s = String(raw).trim();
  if (!s) return "Something went wrong. Try again.";
  if (s.length > 204) return "Something went wrong. Try again.";
  const lower = s.toLowerCase();
  if (
    lower.includes("base64") ||
    lower.includes("frombase64") ||
    lower.includes("system.") ||
    lower.includes("stack trace") ||
    lower.includes("microsoft") ||
    (lower.includes("sql") && lower.includes("error")) ||
    lower.includes("inner exception")
  ) {
    return "Something went wrong. Try again.";
  }
  if (s.length > 80 && /at\s+\S+\s+in\s+/i.test(s)) {
    return "Something went wrong. Try again.";
  }
  return s.slice(0, 400);
}
